import React from 'react';
import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  SearchFieldV2 as SearchField,
  FormFieldV2 as FormField
} from '@/components/custom/erp';
import { QUERY_KEYS, warehouseSearchColumns } from '@/constants';
import { Label } from '@/components/ui/label';
import { KhoHang } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  // Props for search field states
  selectedWarehouse: KhoHang | null;
  setSelectedWarehouse: (warehouse: KhoHang | null) => void;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode, selectedWarehouse, setSelectedWarehouse }) => {
  return (
    <div className='space-y-1 p-4'>
      {/* Ngày c/từ (từ/đến) - Date Range */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2
          fromDateName='from_date'
          toDateName='to_date'
          toFieldClassName='w-44'
          fromFieldClassName='w-44'
        />
      </div>

      {/* Số c/từ (từ/đến) - Document Number Range */}
      <div className='flex items-center'>
        <DocumentNumberRangeField
          fromName='from_number'
          toName='to_number'
          labelClassName='w-40 min-w-40'
          label='Số c/từ (từ/đến)'
        />
      </div>

      {/* Loại xuất - Export Type */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Loại xuất</Label>
        <FormField
          className='min-w-[200px]'
          type='select'
          name='loai_xuat'
          disabled={formMode === 'view'}
          options={[
            { label: 'Tất cả', value: '' },
            { label: 'Điều chuyển', value: 'DC' },
            { label: 'Xuất khác', value: 'XK' },
            { label: 'Xuất nội bộ', value: 'NB' }
          ]}
        />
      </div>

      {/* Giao dịch - Transaction */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Giao dịch</Label>
        <FormField
          className='min-w-[200px]'
          type='select'
          name='giao_dich'
          disabled={formMode === 'view'}
          options={[
            { label: 'Tất cả', value: '' },
            { label: 'DC. Điều chuyển', value: 'DC' },
            { label: 'XK. Xuất khác', value: 'XK' },
            { label: 'NB. Xuất nội bộ', value: 'NB' }
          ]}
        />
      </div>

      {/* Mã kho xuất - Export Warehouse Search Field */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Mã kho xuất</Label>
        <div className='w-full'>
          <SearchField<KhoHang>
            type='text'
            displayRelatedField='ten_kho'
            columnDisplay='ma_kho'
            className='w-[180px]'
            searchEndpoint={`/${QUERY_KEYS.KHO_HANG}`}
            searchColumns={warehouseSearchColumns}
            dialogTitle='Danh mục kho hàng'
            disabled={formMode === 'view'}
            onValueChange={value => setSelectedWarehouse({ ...selectedWarehouse, ma_kho: value } as KhoHang)}
            onRowSelection={(row: KhoHang) => setSelectedWarehouse(row)}
          />
        </div>
      </div>

      {/* Diễn giải - Description Field */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Diễn giải</Label>
        <div className='flex-1'>
          <FormField className='w-full' type='text' name='dien_giai' disabled={formMode === 'view'} />
        </div>
      </div>
    </div>
  );
};
